var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{staticClass:"hero-text"},[_vm._t("before"),_c('strong',[_vm._v(_vm._s(_vm._f("format")(_vm.props.rdv.day,"EEEE d MMMM")))]),_c('p',[_vm._v(" entre "+_vm._s(_vm._f("format")(_vm.props.rdv.start,"H:mm"))+" et "+_vm._s(_vm._f("format")(_vm.props.rdv.end,"H:mm"))+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }